import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {WhoisOnlineService} from '@app/services/IdleAndWhoseOnline/whois-online.service';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {fuseAnimations} from '../../../../../@fuse/animations';
import {UserContext} from '@models/user';
import {AuthService} from '@app/services/auth/auth.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

import * as uuid from 'uuid';

@Component({
    selector: 'app-who-is-online',
    templateUrl: './who-is-online.component.html',
    styleUrls: ['./who-is-online.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class WhoIsOnlineComponent extends OnDestroyMixin implements OnInit {

  displaySuperAdminNameAsk = false;

  userContext: UserContext = this.authService.getContext();

  godMode = false;

  fName: UntypedFormGroup;

  userList: any[] = []; // ✅ Tableau pour *ngFor
  nbUsers = 0;
  isLoggedToFirebase = true; // Maintenant on est pas mal déjà connecté quand tout ça s'affiche non ?

  constructor(
    private store: Store<AppState>, // private socket: Socket,
    public authService: AuthService,
    private whoisOnlineService: WhoisOnlineService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.fName = new UntypedFormGroup({
      name: new UntypedFormControl(this.authService.getDisplayName(), [Validators.required]),
    });

    this.whoisOnlineService.whoIsOnline$
      .pipe(
        untilComponentDestroyed(this)
      ).subscribe((userList) => {

      if (userList) {
        this.nbUsers = Object.keys(userList)?.length || 0;
        // ✅ Convertir l'objet en tableau pour *ngFor
        this.userList = Object.values(userList);
        // console.log(userList);
        // console.log('Userslist value changed!!!!', this.nbUsers, this.userList);
      } else {
        this.nbUsers = 0;
        this.userList = [];
      }

      if (this.authService.getContext().userAccess?.includes('GOD_MODE')) {

        this.godMode = true;

        //
        // Est-ce qu'on a un 'super-UUID' ?
        //
        const superUuid = localStorage?.getItem('superUuid') || false;

        if (!superUuid) {
          this.displaySuperAdminNameAsk = true;
        } else {
          const realName = JSON.parse(superUuid).name;
          this.fName.get('name').patchValue(realName, {emitEvent: false});
        }

      }
    });

  }

  hideSuperAdminAsk() {
    this.displaySuperAdminNameAsk = false;
  }

  confirmSuperUser() {
    const newUuid = {
      uuid: uuid.v4(),
      name: this.fName.get('name').value
    };
    localStorage.setItem('superUuid', JSON.stringify(newUuid));
    this.displaySuperAdminNameAsk = false;
    this.whoisOnlineService.logActivity();
  }
}
